import React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'
import { AccountStatus, Agent } from '@smartsupp/websocket-client-visitor'

import { agentsSelectors } from 'store/agent'
import { generalSelectors } from 'store/general'
import { TranslationService as T } from 'utils/TranslationService'

import { smartColors } from 'styles/colors'

type Props = {
	triggerVersion?: boolean
}

const renderAgentNames = (joinedAgents: Agent[]) => joinedAgents.map(n => ` ${n.fullname}`).join()

const renderHeadline = (widgetStatus: AccountStatus, joinedAgents: Agent[]) => {
	const possibleScenarios = [
		{
			widgetStatus: AccountStatus.Offline,
			hasJoinedAgents: true,
			text: renderAgentNames(joinedAgents),
		},
		{
			widgetStatus: AccountStatus.Offline,
			hasJoinedAgents: false,
			text: T.translate('topBar.offline.hello'),
		},
		{
			widgetStatus: AccountStatus.Online,
			hasJoinedAgents: true,
			text: renderAgentNames(joinedAgents),
		},
		{
			widgetStatus: AccountStatus.Online,
			hasJoinedAgents: false,
			text: T.translate('topBar.online.hello'),
		},
	]

	const hasJoinedAgents = joinedAgents.length > 0

	const currentScenario = possibleScenarios.find(
		s => s.widgetStatus === widgetStatus && s.hasJoinedAgents === hasJoinedAgents,
	)
	if (currentScenario) {
		return currentScenario.text
	}

	return false
}

const ChatHeaderTitle = ({ triggerVersion }: Props) => {
	const joinedAgents = useSelector(agentsSelectors.getReversedJoinedAgents)
	const widgetStatus = useSelector(agentsSelectors.getWidgetStatus)
	const theme = useSelector(generalSelectors.theme)

	return (
		<Box
			data-testid="triggerHeader"
			pt={triggerVersion ? 0.75 : 0.25}
			overflow="hidden"
			textOverflow="ellipsis"
			whiteSpace="nowrap"
			fontSize={triggerVersion ? 15 : 18}
			fontWeight={triggerVersion ? 700 : 400}
			color={triggerVersion ? smartColors.blackTextColor : theme.textColor}
		>
			{renderHeadline(widgetStatus, joinedAgents)}
		</Box>
	)
}

export default ChatHeaderTitle
